fragment Webcast on Webcast {
    id
    name
    registrationUrl
    timestamp
    isCurrentUserRegistered
}
